import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VTooltip,
        _vm._b(
          {
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      VBtn,
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              color: _vm.buttonProps.color,
                              icon: _vm.iconMode,
                              dark: _vm.dark,
                              to: _vm.to,
                            },
                          },
                          "v-btn",
                          { ...attrs, ..._vm.$attrs },
                          false
                        ),
                        { ...on, ..._vm.$listeners }
                      ),
                      [
                        _vm.iconShow
                          ? _c(VIcon, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.buttonProps.icon) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.iconMode
                          ? _c("div", { staticClass: "ml-1" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.buttonProps.label) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.badgeContent
                          ? _c(VBadge, {
                              attrs: { inline: "", content: _vm.badgeContent },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          },
          "v-tooltip",
          _vm.tooltipProps,
          false
        ),
        [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.buttonProps.label))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }